import { useEffect } from 'react'
import { fb } from '../../lib/firebase'

interface Params {
  redirectUrl: string
}

export const Registration = ({redirectUrl}: Params) => {
  useEffect(() => {
    if(!fb.isSignedIn()) {
      fb.renderSignIn(redirectUrl);
    }
  })

  return (
    <div id="firebaseui-auth-container" className="flex"></div>
  )
}
